// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { RefObject, useEffect, useRef, useState } from 'react';

export function useHorizontalScrollIndicator(ref: RefObject<HTMLElement>) {
  const intervalRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      if (ref.current === null) {
        return false;
      }

      const canScroll = ref.current.scrollWidth > ref.current.clientWidth;

      const scrollDifference =
        ref.current.scrollWidth - ref.current.clientWidth;
      const isVisible =
        canScroll && ref.current.scrollLeft < scrollDifference - 16;

      if (isVisible) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }, 250);

    return () => {
      if (intervalRef.current === null) {
        return;
      }

      clearInterval(intervalRef.current);
    };
  }, [ref]);

  const show = () => {
    setIsVisible(true);
  };

  const hide = () => {
    setIsVisible(false);
  };

  return { isVisible, show, hide };
}
